import { CertificateAddress } from './CertificateAddress'
import { withCertificateAddress } from './withCertificateAddress'

const ConnectedCertificateAddress = withCertificateAddress(CertificateAddress)
export { ConnectedCertificateAddress as CertificateAddress }
